var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "BjDivider",
        { attrs: { "right-fixed": "" } },
        [
          _vm._v(_vm._s(_vm.$t("goodsSku.detail.BasicInformation")) + " "),
          _c(
            "template",
            { slot: "right" },
            [
              _vm.isAdd && !_vm.type
                ? [
                    _c("el-button", { on: { click: _vm.tryCancel } }, [
                      _vm._v(_vm._s(_vm.$t("cancelText"))),
                    ]),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.handleConfirm(false)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("saveText")))]
                    ),
                  ]
                : _vm._e(),
              _vm.isView
                ? [
                    _c(
                      "el-button",
                      { attrs: { type: "primary" }, on: { click: _vm.cancel } },
                      [_vm._v(_vm._s(_vm.$t("backText")))]
                    ),
                    !_vm.$store.getters.cusId
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.showLog },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "BusinessPurchaseApplyDetail.operationLog"
                                )
                              )
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ],
        2
      ),
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "form",
          attrs: {
            model: _vm.goodsData,
            rules: _vm.rules,
            "label-width": "230px",
            disabled: !!_vm.type,
          },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("goodsPage.skuName"),
                        prop: "skuName",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          autosize: "",
                          maxlength: _vm.MAX_LENGTH.REMARK,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.goodsData.skuName,
                          callback: function ($$v) {
                            _vm.$set(_vm.goodsData, "skuName", $$v)
                          },
                          expression: "goodsData.skuName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.$route.query.id
                ? _c(
                    "el-col",
                    { attrs: { span: _vm.colSpan } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("goodsPage.skuCode"),
                            prop: "skuCode",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              disabled: !!_vm.$route.query.id,
                              autosize: "",
                              maxlength: _vm.MAX_LENGTH.NORMAL,
                              placeholder: _vm.$t("inputText"),
                              clearable: "",
                            },
                            model: {
                              value: _vm.goodsData.standardSkuCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.goodsData, "standardSkuCode", $$v)
                              },
                              expression: "goodsData.standardSkuCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _c(
                    "el-col",
                    { attrs: { span: _vm.colSpan } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("goodsPage.skuCode"),
                            prop: "skuCode",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              disabled: !!_vm.$route.query.id,
                              autosize: "",
                              maxlength: _vm.MAX_LENGTH.NORMAL,
                              placeholder: _vm.$t("inputText"),
                              clearable: "",
                            },
                            model: {
                              value: _vm.goodsData.skuCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.goodsData, "skuCode", $$v)
                              },
                              expression: "goodsData.skuCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("goodsPage.need"),
                        prop: "needExpired",
                      },
                    },
                    [
                      _c("el-switch", {
                        attrs: {
                          "active-color": "#082dc3",
                          "inactive-color": "",
                        },
                        model: {
                          value: _vm.goodsData.needExpired,
                          callback: function ($$v) {
                            _vm.$set(_vm.goodsData, "needExpired", $$v)
                          },
                          expression: "goodsData.needExpired",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("goodsSku.detail.Barcode"),
                        prop: "barCode",
                      },
                    },
                    [
                      _c(
                        "label",
                        { attrs: { slot: "label" }, slot: "label" },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("goodsSku.detail.Barcode")) + " "
                          ),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                effect: "dark",
                                content: _vm.$t("goodsSku.detail.barcodeTip"),
                                placement: "top",
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-question",
                                staticStyle: { color: "#4d08ed" },
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c("BjInput", {
                        attrs: {
                          disabled: _vm.barCodeDisStatus,
                          maxlength: 14,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.goodsData.barCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.goodsData, "barCode", $$v)
                          },
                          expression: "goodsData.barCode",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("goodsPage.costPrice"),
                        prop: "costPrice",
                      },
                    },
                    [
                      _c("BjInputMoney", {
                        attrs: {
                          placeholder: _vm.$t("goodsPage.costPrice"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.goodsData.costPrice,
                          callback: function ($$v) {
                            _vm.$set(_vm.goodsData, "costPrice", $$v)
                          },
                          expression: "goodsData.costPrice",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("goodsPage.Serial"),
                        prop: "needSerialNo",
                      },
                    },
                    [
                      _c("el-switch", {
                        attrs: {
                          "active-color": "#082dc3",
                          "inactive-color": "",
                        },
                        model: {
                          value: _vm.goodsData.needSerialNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.goodsData, "needSerialNo", $$v)
                          },
                          expression: "goodsData.needSerialNo",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("goodsSku.detail.itemPerCarton"),
                        prop: "qty",
                      },
                    },
                    [
                      _c("BjInputNumber", {
                        attrs: { min: 1 },
                        model: {
                          value: _vm.goodsData.qty,
                          callback: function ($$v) {
                            _vm.$set(_vm.goodsData, "qty", $$v)
                          },
                          expression: "goodsData.qty",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("goodsSku.detail.isWine"),
                        prop: "fragile",
                      },
                    },
                    [
                      _c("BjSelectLov", {
                        attrs: {
                          "option-list": _vm.STATUS_YES_NUMBER,
                          placeholder: _vm.$t("chooseText"),
                        },
                        model: {
                          value: _vm.goodsData.fragile,
                          callback: function ($$v) {
                            _vm.$set(_vm.goodsData, "fragile", $$v)
                          },
                          expression: "goodsData.fragile",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("goodsPage.dangerousGoods"),
                        prop: "dangerousGoods",
                      },
                    },
                    [
                      _c("el-switch", {
                        attrs: {
                          "active-color": "#082dc3",
                          "inactive-color": "",
                        },
                        model: {
                          value: _vm.goodsData.dangerousGoods,
                          callback: function ($$v) {
                            _vm.$set(_vm.goodsData, "dangerousGoods", $$v)
                          },
                          expression: "goodsData.dangerousGoods",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("goodsSku.detail.originPlace"),
                        prop: "originPlace",
                      },
                    },
                    [
                      _c("BjSelectLov", {
                        attrs: {
                          "option-list": _vm.COUNTRY_NAME_AND_TWOCODE,
                          placeholder: _vm.$t("chooseText"),
                        },
                        model: {
                          value: _vm.goodsData.originPlace,
                          callback: function ($$v) {
                            _vm.$set(_vm.goodsData, "originPlace", $$v)
                          },
                          expression: "goodsData.originPlace",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("goodsSku.detail.hsCode"),
                        prop: "hsCode",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: 14,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.goodsData.hsCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.goodsData, "hsCode", $$v)
                          },
                          expression: "goodsData.hsCode",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan * 2 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("goodsSku.detail.skuDesc"),
                        prop: "skuDesc",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          type: "textarea",
                          "show-word-limit": "",
                          autosize: "",
                          maxlength: _vm.MAX_LENGTH.PRIORITY,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.goodsData.skuDesc,
                          callback: function ($$v) {
                            _vm.$set(_vm.goodsData, "skuDesc", $$v)
                          },
                          expression: "goodsData.skuDesc",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("BjDivider", { staticStyle: { "margin-top": "20px" } }, [
            _vm._v(_vm._s(_vm.$t("goodsSku.detail.AttributeTable"))),
          ]),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("goodsSku.detail.length"),
                        prop: "length",
                      },
                    },
                    [
                      _c(
                        "BjInputMoney",
                        {
                          model: {
                            value: _vm.goodsData.length,
                            callback: function ($$v) {
                              _vm.$set(_vm.goodsData, "length", $$v)
                            },
                            expression: "goodsData.length",
                          },
                        },
                        [_c("template", { slot: "append" }, [_vm._v("cm")])],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("goodsSku.detail.width"),
                        prop: "width",
                      },
                    },
                    [
                      _c(
                        "BjInputMoney",
                        {
                          model: {
                            value: _vm.goodsData.width,
                            callback: function ($$v) {
                              _vm.$set(_vm.goodsData, "width", $$v)
                            },
                            expression: "goodsData.width",
                          },
                        },
                        [_c("template", { slot: "append" }, [_vm._v("cm")])],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("goodsSku.detail.height"),
                        prop: "height",
                      },
                    },
                    [
                      _c(
                        "BjInputMoney",
                        {
                          model: {
                            value: _vm.goodsData.height,
                            callback: function ($$v) {
                              _vm.$set(_vm.goodsData, "height", $$v)
                            },
                            expression: "goodsData.height",
                          },
                        },
                        [_c("template", { slot: "append" }, [_vm._v("cm")])],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("goodsSku.detail.weight"),
                        prop: "weight",
                      },
                    },
                    [
                      _c(
                        "BjInputMoney",
                        {
                          model: {
                            value: _vm.goodsData.weight,
                            callback: function ($$v) {
                              _vm.$set(_vm.goodsData, "weight", $$v)
                            },
                            expression: "goodsData.weight",
                          },
                        },
                        [_c("template", { slot: "append" }, [_vm._v("kg")])],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("goodsSku.detail.cartonLength"),
                        prop: "cartonLength",
                        rules:
                          _vm.goodsData.qty > 1
                            ? _vm.rules.cartonLength
                            : [{ required: false }],
                      },
                    },
                    [
                      _c(
                        "BjInputMoney",
                        {
                          model: {
                            value: _vm.goodsData.cartonLength,
                            callback: function ($$v) {
                              _vm.$set(_vm.goodsData, "cartonLength", $$v)
                            },
                            expression: "goodsData.cartonLength",
                          },
                        },
                        [_c("template", { slot: "append" }, [_vm._v("cm")])],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("goodsSku.detail.cartonWidth"),
                        prop: "cartonWidth",
                        rules:
                          _vm.goodsData.qty > 1
                            ? _vm.rules.cartonWidth
                            : [{ required: false }],
                      },
                    },
                    [
                      _c(
                        "BjInputMoney",
                        {
                          model: {
                            value: _vm.goodsData.cartonWidth,
                            callback: function ($$v) {
                              _vm.$set(_vm.goodsData, "cartonWidth", $$v)
                            },
                            expression: "goodsData.cartonWidth",
                          },
                        },
                        [_c("template", { slot: "append" }, [_vm._v("cm")])],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("goodsSku.detail.cartonHeight"),
                        prop: "cartonHeight",
                        rules:
                          _vm.goodsData.qty > 1
                            ? _vm.rules.cartonHeight
                            : [{ required: false }],
                      },
                    },
                    [
                      _c(
                        "BjInputMoney",
                        {
                          model: {
                            value: _vm.goodsData.cartonHeight,
                            callback: function ($$v) {
                              _vm.$set(_vm.goodsData, "cartonHeight", $$v)
                            },
                            expression: "goodsData.cartonHeight",
                          },
                        },
                        [_c("template", { slot: "append" }, [_vm._v("cm")])],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("goodsSku.detail.cartonWeight"),
                        prop: "cartonWeight",
                        rules:
                          _vm.goodsData.qty > 1
                            ? _vm.rules.cartonWeight
                            : [{ required: false }],
                      },
                    },
                    [
                      _c(
                        "BjInputMoney",
                        {
                          model: {
                            value: _vm.goodsData.cartonWeight,
                            callback: function ($$v) {
                              _vm.$set(_vm.goodsData, "cartonWeight", $$v)
                            },
                            expression: "goodsData.cartonWeight",
                          },
                        },
                        [_c("template", { slot: "append" }, [_vm._v("kg")])],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.goodsData.itemType == "item" &&
          this.$store.state.user.permissionBtns.includes(
            "BusinessGoodsPackageManagement".toLocaleLowerCase()
          )
            ? [
                (_vm.isAdd && !_vm.type) || _vm.isView
                  ? _c("BjDivider", { staticStyle: { "margin-top": "20px" } }, [
                      _vm._v(_vm._s(_vm.$t("goodsPage.package.Info"))),
                    ])
                  : _vm._e(),
                _vm._l(_vm.packageInfo.packageList, function (item, index) {
                  return _c(
                    "el-row",
                    { key: index },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label:
                                  index == 0
                                    ? _vm.$t("goodsPage.package.order")
                                    : _vm.$t("goodsPage.package.product"),
                                prop: "order",
                              },
                            },
                            [
                              _c(
                                "el-input",
                                {
                                  attrs: {
                                    disabled: "",
                                    placeholder: _vm.$t("chooseText"),
                                  },
                                  model: {
                                    value: item.skuName,
                                    callback: function ($$v) {
                                      _vm.$set(item, "skuName", $$v)
                                    },
                                    expression: "item.skuName",
                                  },
                                },
                                [
                                  _c(
                                    "template",
                                    { slot: "append" },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            disabled: !_vm.$store.getters.cusId,
                                            type: "primary",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.choosePackage(index)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "goodsPage.package.Selectpackagingmaterials"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "delete-btn",
                          staticStyle: { "margin-left": "10px" },
                          attrs: {
                            disabled: !_vm.$store.getters.cusId,
                            type: "text",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.onDelete(index)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("delText")))]
                      ),
                    ],
                    1
                  )
                }),
              ]
            : _vm._e(),
          _c("BjDialogList", {
            ref: "BjDialogPackageList",
            attrs: {
              width: "80%",
              config: _vm.$BjDialogListConfig.packageDefault(
                _vm.$t("goodsPage.package.Selectpackagingmaterials"),
                { defaultQuery: _vm.defaultQuery }
              ),
            },
            on: { confirm: _vm.confirmDialogList },
          }),
          _c("BjDivider", { staticStyle: { "margin-top": "20px" } }, [
            _vm._v(_vm._s(_vm.$t("goodsPage.rule"))),
          ]),
          _c("el-row", [_c("skuRule")], 1),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }